import { authActions } from '@/redux/actions'
import { isFailureAction } from '@/utils/actions.utils'
import { LOGOUT, REFRESH_TOKEN } from '@/redux/actions/auth.actions'
import { uiActions } from '../actions'

const actionNeedsCheck = (action) => {
	const excludeRequestActions = [LOGOUT.FAILURE, REFRESH_TOKEN.FAILURE]

	if (isFailureAction(action.type) && !excludeRequestActions.includes(action.type)) {
		return true
	}

	return false
}

const notAuthorized = (store) => (next) => async (action) => {
	const { dispatch } = store

	if (!actionNeedsCheck(action) || action.error?.response?.status !== 401) {
		return next(action)
	}

	await dispatch(authActions.logout(false))
	await dispatch(uiActions.navigateTo({ path: '/' }))
	return next({ ...action, showError: false })
}

export default notAuthorized
